"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CssLoader = _interopRequireDefault(require("@cimpress/react-components/lib/CssLoader"));

var _reactRedux = require("react-redux");

var _lib = require("@cimpress/react-components/lib");

var _snackbar = require("../../actions/snackbar");

function Shell(_ref) {
  var children = _ref.children,
      snackbar = _ref.snackbar,
      hideSnackbar = _ref.hideSnackbar;
  return /*#__PURE__*/_react["default"].createElement(_CssLoader["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '5px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_lib.Snackbar, {
    show: snackbar.show,
    status: snackbar.status,
    onHideSnackbar: hideSnackbar
  }, snackbar.message), children));
}

var _default = (0, _reactRedux.connect)(function (_ref2) {
  var snackbar = _ref2.snackbar;
  return {
    snackbar: snackbar
  };
}, {
  hideSnackbar: _snackbar.hideSnackbar
})(Shell);

exports["default"] = _default;